import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="bg-light border-bottom">
      <div className="container py-5">
        <div className="row align-items-center g-4">
          {/* LEFT: headline + CTAs */}
          <div className="col-lg-6">
            <h1 className="display-5 fw-bold">
              <span className='text-danger'>Safe, On-Time</span> <span className="text-primary">Non-Emergency Medical Transportation</span>
            </h1>
            <p className="lead text-secondary mt-3">
              Ambulatory, wheelchair, and stretcher rides for appointments, dialysis, therapy, discharges, and more.
            </p>
            <div className="d-flex gap-2 mt-3">
              <Link className="btn btn-primary btn-lg" to="/booking">Schedule Now</Link>
              <a className="btn btn-outline-secondary btn-lg" href="tel:+1 (651) 283-7169">Call</a>
            </div>
            <ul className="mt-4 text-secondary">
              <li>ADA-compliant vehicles</li>
              <li>Trained, CPR-aware drivers</li>
              <li>Door-through-door assistance</li>
              <li>SMS updates available</li>
            </ul>
          </div>

          {/* RIGHT: Bootstrap Carousel */}
          <div className="col-lg-6">
            <div id="heroCarousel" className="carousel slide" data-bs-ride="carousel">
              <div className="carousel-indicators">
                <button type="button" data-bs-target="#heroCarousel" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                <button type="button" data-bs-target="#heroCarousel" data-bs-slide-to="1" aria-label="Slide 2"></button>
                <button type="button" data-bs-target="#heroCarousel" data-bs-slide-to="2" aria-label="Slide 3"></button>
                <button type="button" data-bs-target="#heroCarousel" data-bs-slide-to="3" aria-label="Slide 4"></button>
              </div>

              {/* Keep a nice 4:3 area and crop images to fill */}
              <div className="ratio ratio-4x3 rounded-3 overflow-hidden">
                <div className="carousel-inner h-100">
                  <div className="carousel-item active h-100">
                    <img
                      src="/images/fleet-wheelchair.jpg"
                      className="d-block w-100 h-100 object-cover"
                      alt="Bis itella black van"
                    />
                  </div>
                  <div className="carousel-item h-100">
                    <img
                      src="/images/fleet-ambulatory.jpg"
                      className="d-block w-100 h-100 object-cover"
                      alt="Bis itella red van"
                    />
                  </div>
                  <div className="carousel-item h-100">
                    <img
                      src="/images/suv-black.jpg"
                      className="d-block w-100 h-100 object-cover"
                      alt="Bis itella SUV"
                    />
                  </div>
                  <div className="carousel-item h-100">
                    <img
                      src="/images/fleet-wheelchair.jpg"
                      className="d-block w-100 h-100 object-cover"
                      alt="Bis itella sedan"
                    />
                  </div>
                </div>
              </div>

              <button className="carousel-control-prev" type="button" data-bs-target="#heroCarousel" data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
              </button>
              <button className="carousel-control-next" type="button" data-bs-target="#heroCarousel" data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
